
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 9h3.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H19V4.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V8a1 1 0 001 1zM6 9a1 1 0 001-1V4.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V7H2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H6zm13 10.5V17h2.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H18a1 1 0 00-1 1v3.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5zM5.5 20h1a.5.5 0 00.5-.5V16a1 1 0 00-1-1H2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H5v2.5a.5.5 0 00.5.5z","fill":"#000"}})])
          )
        }
      }
    